import { ERouterList } from '@internal/router/constants/router-list'

export const notFound = [
  {
    path: '/not-found',
    name: ERouterList.NOT_FOUND,
    component: () => import('@internal/pages/404.vue'),
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: {
      name: ERouterList.NOT_FOUND,
    },
  },
]

export default notFound
